let _formInstances = new WeakMap<Element, Form>();
let _formFieldInstances = new WeakMap<Element, FormField>();

enum FormMode {
    Ajax,
    Normal
}

class Form  extends EventTarget {
    elForm:    HTMLFormElement;
    mode:      FormMode;
    fields:    Array<FormField> = [];

    constructor(form: Element) {
        super();

        this.elForm  = form as HTMLFormElement;

        this.mode = this.elForm.classList.contains("ajax") ? FormMode.Ajax : FormMode.Normal;

        this.init();

        _formInstances.set(form, this);
    }

    static instance(el: Element): Form|null {
        return _formInstances.get(el);
    }

    init() {

        this.elForm.querySelectorAll(".form-field").forEach((el) => {
            const ff = FormField.fromElement(el)

            if (ff) {
                this.fields.push(ff);
            }
        })

        // Take over validation
        this.elForm.setAttribute('novalidate', 'novalidate');

        this.elForm.addEventListener("submit", (e) => {
            if (this.mode == FormMode.Ajax) {
                e.preventDefault();
                if (!this.validateAllFields()) {
                    e.stopPropagation();
                } else {

                    var data = new FormData(this.elForm);

                    this.elForm.dispatchEvent(new CustomEvent("form.submit", {
                        detail: {
                            form: this,
                            data: data
                        }
                    }));

                    fetch(this.elForm.action, {
                        method: this.elForm.method,
                        body: data,
                        headers: {
                            'Accept': 'application/json',
                        }
                    }).then(res => {
                        if (res.ok) {
                            res.json().then(data => {

                                if (data.success) {
                                    this.elForm.reset();

                                    this.dispatchEvent(new CustomEvent("form.submit.success", {
                                        detail: {
                                            form: this,
                                            data: data
                                        }
                                    }));
                                } else {
                                    this.dispatchEvent(new CustomEvent("form.submit.error", {
                                        detail: {
                                            form: this,
                                            data: data
                                        }
                                    }));
                                }
                            })
                        }
                    }).catch(error => {
                        console.error("Failed to submit form: ", error);

                        this.elForm.dispatchEvent(new CustomEvent("form.submit.error", {
                            detail: {
                                form: this,
                                error: error,
                            }
                        }));
                    });
                }
            } else {
                if (!this.validateAllFields()) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
                // Submit event goes through
            }
        })
    }

    validateAllFields(): boolean {
        let allOk = true;

        this.fields.forEach((f) => {
            const r = f.validate();

            allOk = allOk && r;
        })

        return allOk;
    }

}

class FormField {

    el: HTMLElement;
    type: string = "simple";

    constructor(el: Element) {
        this.el = el as HTMLElement;

        this.init();

        _formFieldInstances.set(el, this);
    }

    static fromElement(el: Element): FormField|null {
        if (_formFieldInstances.has(el)) {
            return _formFieldInstances.get(el);
        }

        return new FormField(el);
    }
    
    init() {
        // Detect field type

        this.el.addEventListener("focusout", (e) => {
            this.validate();
        })
    }

    isRequired(): boolean {
        return this.el.classList.contains('form-field-required');
    }

    hasValue(): boolean {
        return this.getValue().length > 0;
    }

    getValue(): Array<string> {
        let value: Array<string> = [];

        if (this.type == "simple") {
            
            this.el.querySelectorAll("input.form-input-value").forEach((i: HTMLInputElement) => {
                if (i.value != "") {
                    value.push(i.value);
                }
            })
            this.el.querySelectorAll("select.form-input-value").forEach((i: HTMLSelectElement) => {
                if (i.value != "") {
                    value.push(i.value);
                }
            })
        }
        return value;
    }

    validate(): boolean {

        this.el.classList.remove('form-field-required-empty');

        if (this.isRequired()) {
            if (!this.hasValue()) {

                this.el.classList.add('form-field-required-empty');

                return false;
            }
        }

        return true;
    }
}





export { Form, FormField };
